import {
	Currency,
	GameplayActivityTimerIcon,
	GameplayJobProgressIcon,
	IGameplayActivityTimer,
	IGameplayJobProgress,
	MainMenuTabs,
	formatTime,
} from '~/shared';
import { IObservable, Subject } from '../../utils';
import {
	IGameArea,
	IGameService,
	IRealTime,
	IServerNewsPost,
	IServerNewsPostShort,
	PromotionType,
} from './gameServiceTypes';

export class GameServiceStub implements IGameService {
	private onlinePlayers = new Subject(Math.round(100 + Math.random() * 900));
	private activityTimer = new Subject<IGameplayActivityTimer | null>(null);
	private jobProgress = new Subject<IGameplayJobProgress | null>(null);
	private gameTime = new Subject<string>('00:00');
	private realTime = new Subject<IRealTime>({
		time: '00:00',
		weekday: 'Четверг',
		weekdayShort: 'Чт',
		date: '17 октября',
		dateShort: '17 окт.',
		month: 'Октябрь',
	});

	private isInGreenZone = new Subject<boolean>(true);

	private area = new Subject<IGameArea>({
		primaryName: 'Истборн - Вэй',
		secondaryName: 'Рокфорд Хиллз',
	});
	private serverId = new Subject<string>('Test');
	private serverName = new Subject<string>('Los Santos');
	private activePromotion = new Subject<PromotionType | null>(
		PromotionType.DonateX2,
	);
	private defaultMainMenuTab = new Subject<MainMenuTabs | null>(null);
	private interactVisible = new Subject<boolean>(true);

	private serverNews = new Subject([
		{
			id: 'test-news-item-1',
			date: Date.now(),
			title: 'Открытие проекта',
			shortText: `Поздравляем всех наших игроков, которые долго ждали открытие
нашего проекта! Мы шли к этому возраждению долгое время и
стараемся и дальше реализовывать наши задумки, которые вы скоро
увидите...
`,
			text: `Поздравляем всех наших игроков, которые долго ждали открытие нашего
проекта и вместа с нами приодолевали все трудности, которые стояли у
нас на пути!

Мы полностью переработали все механики проекта, учли и решили все
проблемы предыдущего открытия и даём вам возможность насладится всем
этим вместе с нами!

В данный момент проект находится в стадии “БЕТА” так как
некоторые превычные для вас системы находятся на переработке и
вскоре будут добавлены на сервер. Ниже мы расскажем, какие системы в
ближайшее время стоит ожидать


- Бизнесы
- Торговая площадка
- Инвентарь
- Новые работы
- Новые автомобили

Все это мы добавим в ближайших обновлениях и закроем статус “БЕТА”
Мы очень признательны что вы ждали открытия, верили в нас. Ваша
команда, CCDPlanet!`,
		},
		{
			id: 'test-news-item-111',
			date: Date.now(),
			title:
				'Очень длинная новость с невероятно длинным заголовком, который содержит множество слов и описывает все аспекты нашего грандиозного обновления, включая новые системы, механики, автомобили, работы, бизнесы, фракции, мафии, дома, предметы, скины и множество других интересных и захватывающих нововведений, которые кардинально изменят игровой процесс и подарят вам незабываемые впечатления от игры на нашем сервере',
			shortText: `Поздравляем всех наших игроков
`,
			text: `Поздравляем всех наших игроков, которые долго ждали открытие нашего проекта и вместе с нами преодолевали все трудности, которые стояли у нас на пути! Сегодня мы рады представить вам самое масштабное и грандиозное обновление за всю историю существования нашего проекта, которое включает в себя невероятное количество новых систем, механик, контента и возможностей для игроков.

Мы полностью переработали все механики проекта, учли и решили все проблемы предыдущего открытия и даём вам возможность насладиться всем этим вместе с нами! Наша команда разработчиков работала без устали на протяжении многих месяцев, чтобы создать для вас поистине уникальный и захватывающий игровой опыт, который превзойдет все ваши ожидания и подарит незабываемые впечатления от игры на нашем сервере.

В данный момент проект находится в стадии "БЕТА" так как некоторые привычные для вас системы находятся на переработке и вскоре будут добавлены на сервер. Однако мы уже готовы представить вам множество новых и улучшенных систем, которые кардинально изменят ваш игровой опыт и откроют новые возможности для развития и развлечения.

Ниже мы расскажем подробно о всех нововведениях, которые вы сможете увидеть в ближайшее время и которые уже частично доступны на сервере. Каждая из этих систем была разработана с учетом пожеланий и отзывов наших игроков, чтобы сделать игру максимально интересной, сбалансированной и увлекательной для всех участников нашего игрового сообщества.

## Новые системы и механики

### Система бизнесов

Мы полностью переработали систему бизнесов, добавив множество новых возможностей для предпринимателей. Теперь вы можете открыть свой бизнес в различных сферах деятельности, включая автосервисы, магазины, рестораны, бары, ночные клубы, отели, заправочные станции, автомойки, салоны красоты, фитнес-центры и множество других интересных направлений. Каждый бизнес имеет свою уникальную механику работы, систему найма сотрудников, управления финансами и развития. Вы сможете нанимать других игроков в качестве работников, устанавливать цены на свои услуги и товары, проводить рекламные акции, расширять свой бизнес и получать стабильный доход от своей предпринимательской деятельности.

### Торговая площадка

Новая система торговой площадки позволит вам покупать и продавать различные предметы, транспорт, недвижимость и другие ценности напрямую с другими игроками, без посредников. Вы сможете создавать объявления о продаже, устанавливать цены, вести переговоры с покупателями, использовать систему рейтингов и отзывов для оценки надежности продавцов и покупателей. Торговая площадка включает в себя удобную систему поиска, фильтры по категориям, цене, состоянию товара и другим параметрам, что позволит вам быстро найти именно то, что вам нужно.

### Система инвентаря

Полностью переработанная система инвентаря теперь включает в себя множество новых возможностей для управления вашими предметами. Вы сможете организовывать предметы по категориям, создавать наборы для быстрого доступа, использовать систему меток и поиска, передавать предметы другим игрокам, хранить вещи в различных контейнерах и многое другое. Инвентарь теперь поддерживает огромное количество различных предметов, включая оружие, одежду, еду, напитки, инструменты, материалы, документы и множество других полезных вещей.

### Новые работы

Мы добавили множество новых работ, которые позволят вам зарабатывать деньги различными способами. Теперь вы можете работать таксистом, курьером, почтальоном, водителем автобуса, грузчиком, строителем, электриком, сантехником, поваром, официантом, барменом, охранником, водителем грузовика, пилотом самолета, капитаном корабля и во многих других профессиях. Каждая работа имеет свою уникальную механику, систему заданий, уровни сложности и оплату. Вы сможете повышать свой уровень в каждой профессии, открывая доступ к более сложным и высокооплачиваемым заданиям.

### Новые автомобили

В этом обновлении мы добавили более ста новых автомобилей различных классов и категорий. Теперь вы можете приобрести спортивные автомобили, внедорожники, седаны, хэтчбеки, купе, кабриолеты, пикапы, грузовики, мотоциклы, квадроциклы, лодки, самолеты, вертолеты и множество других транспортных средств. Каждый автомобиль имеет уникальные характеристики, систему тюнинга, возможность покраски и модификации. Вы сможете настраивать двигатель, подвеску, тормоза, трансмиссию, устанавливать различные аксессуары и улучшения, чтобы сделать свой транспорт максимально эффективным и стильным.

### Система недвижимости

Мы полностью переработали систему недвижимости, добавив множество новых типов жилья и возможностей для их обустройства. Теперь вы можете приобрести квартиры, апартаменты, дома, виллы, пентхаусы, офисы, склады, гаражи, ангары и множество других объектов недвижимости. Каждый объект можно обставить мебелью, украсить различными предметами интерьера, установить системы безопасности, организовать хранение вещей и создать уютное жилище по своему вкусу.

### Система фракций и мафий

Мы добавили множество новых фракций и мафий, каждая из которых имеет свою уникальную историю, структуру, цели и возможности. Вы сможете вступить в полицию, МЧС, армию, медицинскую службу, правительственные организации, а также в различные криминальные группировки, мафиозные семьи, банды и другие организации. Каждая фракция имеет свою систему рангов, заданий, бонусов и возможностей для развития. Вы сможете участвовать в различных операциях, миссиях, войнах между фракциями и получать уникальные награды и привилегии.

### Система навыков и развития

Новая система навыков позволит вам развивать своего персонажа в различных направлениях. Вы сможете повышать навыки вождения, стрельбы, физической подготовки, общения, бизнеса, криминала и многих других областях. Каждый навык открывает новые возможности и бонусы, делая вашего персонажа более эффективным в выбранных сферах деятельности. Система развития включает в себя множество достижений, наград и титулов, которые вы сможете получить за различные действия и успехи в игре.

### Социальные системы

Мы добавили множество новых социальных систем, которые позволят вам лучше взаимодействовать с другими игроками. Теперь вы можете создавать группы, организации, клубы по интересам, проводить различные мероприятия, организовывать события, участвовать в конкурсах и турнирах, общаться в различных чатах и форумах, обмениваться опытом и знаниями, находить единомышленников и друзей, создавать собственные сообщества и многое другое.

### Система событий и активностей

Новая система событий и активностей включает в себя множество различных мероприятий, которые будут проходить регулярно на сервере. Вы сможете участвовать в гонках, соревнованиях, конкурсах, турнирах, праздничных событиях, специальных акциях и многих других активностях, получая за это уникальные награды, призы и бонусы. Система событий постоянно обновляется, добавляя новые интересные мероприятия и возможности для развлечения и заработка.

## Планы на будущее

Мы продолжаем активно работать над развитием проекта и в ближайшее время планируем добавить еще множество интересных систем и контента. Среди планов на будущее - система образования, система здравоохранения, система транспорта, система экологии, система погоды и времени года, система экономики, система политики, система СМИ, система развлечений и множество других интересных нововведений, которые сделают игру еще более разнообразной и увлекательной.

Все это мы добавим в ближайших обновлениях и закроем статус "БЕТА". Мы очень признательны, что вы ждали открытия, верили в нас и поддерживали наш проект на протяжении всего пути развития. Ваша поддержка и активность - это то, что мотивирует нас продолжать работать над улучшением игры и добавлением нового контента. Мы обещаем, что будем продолжать развивать проект, учитывая ваши пожелания и отзывы, чтобы сделать игру максимально интересной и увлекательной для всех участников нашего игрового сообщества.

Спасибо вам за то, что вы с нами! Желаем вам приятной игры и незабываемых впечатлений от нашего проекта!

С уважением и наилучшими пожеланиями,
Ваша команда, CCDPlanet!`,
		},
		{
			id: 'test-news-item-2',
			date: Date.now(),
			title: 'Новые автомобили',
			shortText: `Мы рады сообщить вам, что в ближайшее время на сервере появятся новые автомобили!`,
			text: `Мы рады сообщить вам, что в ближайшее время на сервере появятся новые автомобили!

Все автомобили будут доступны для покупки в автосалоне, а также
будут доступны для аренды в аренде автомобилей.

Следите за новостями на нашем сервере и не пропустите возможность
приобрести новый автомобиль!`,
		},
		{
			id: 'test-news-item-3',
			date: Date.now(),
			title: 'Новые работы',
			shortText: `Мы добавили новые работы на сервер!`,
			text: `Мы добавили новые работы на сервер!

Теперь вы можете работать в таких сферах как:
- Такси
- Почта
- Курьер
- И многие другие!

Следите за новостями на нашем сервере и не пропустите возможность
получить новый источник дохода!`,
		},
		{
			id: 'test-news-item-4',
			date: Date.now(),
			title: 'Новые бизнесы',
			shortText: `Мы добавили новые бизнесы на сервер!`,
			text: `Мы добавили новые бизнесы на сервер!

Теперь вы можете открыть свой бизнес в таких сферах как:
- Автосервис
- Магазин
- Ресторан
- И многие другие!

Следите за новостями на нашем сервере и не пропустите возможность
открыть свой бизнес!`,
		},
		{
			id: 'test-news-item-5',
			date: Date.now(),
			title: 'Новые системы',
			shortText: `Мы добавили новые системы на сервер!`,
			text: `Мы добавили новые системы на сервер!

Теперь вы можете пользоваться такими системами как:
- Инвентарь
- Торговая площадка
- Бизнесы
- И многие другие!

Следите за новостями на нашем сервере и не пропустите возможность
использовать новые системы!`,
		},
		{
			id: 'test-news-item-6',
			date: Date.now(),
			title: 'Новые предметы',
			shortText: `Мы добавили новые предметы на сервер!`,
			text: `Мы добавили новые предметы на сервер!

Теперь вы можете использовать такие предметы как:
- Оружие
- Одежда
- Транспорт
- И многие другие!

Следите за новостями на нашем сервере и не пропустите возможность
приобрести новые предметы!`,
		},
		{
			id: 'test-news-item-7',
			date: Date.now(),
			title: 'Новые дома',
			shortText: `Мы добавили новые дома на сервер!`,
			text: `Мы добавили новые дома на сервер!

Теперь вы можете приобрести такие дома как:
- Апартаменты
- Дома
- Квартиры
- И многие другие!

Следите за новостями на нашем сервере и не пропустите возможность
приобрести новый дом!`,
		},
		{
			id: 'test-news-item-8',
			date: Date.now(),
			title: 'Новые скины',
			shortText: `Мы добавили новые скины на сервер!`,
			text: `Мы добавили новые скины на сервер!

Теперь вы можете приобрести такие скины как:
- Одежда
- Транспорт
- Оружие
- И многие другие!

Следите за новостями на нашем сервере и не пропустите возможность
приобрести новый скин!`,
		},
		{
			id: 'test-news-item-9',
			date: Date.now(),
			title: 'Новые мафии',
			shortText: `Мы добавили новые мафии на сервер!`,
			text: `Мы добавили новые мафии на сервер!

Теперь вы можете вступить в такие мафии как:
- Гангстеры
- Мафия
- Триада
- И многие другие!

Следите за новостями на нашем сервере и не пропустите возможность
вступить в новую мафию!`,
		},
		{
			id: 'test-news-item-10',
			date: Date.now(),
			title: 'Новые фракции',
			shortText: `Мы добавили новые фракции на сервер!`,
			text: `Мы добавили новые фракции на сервер!

Теперь вы можете вступить в такие фракции как:
- Полиция
- МЧС
- Армия
- И многие другие!

Следите за новостями на нашем сервере и не пропустите возможность
вступить в новую фракцию!`,
		},
		{
			id: 'test-news-item-11',
			date: Date.now(),
			title: 'Новые друзья',
			shortText: `Мы добавили новых друзей на сервер!`,
			text: `Мы добавили новых друзей на сервер!

Теперь вы можете найти таких друзей как:
- Парень
- Девушка
- Друг
- И многие другие!

Следите за новостями на нашем сервере и не пропустите возможность
найти новых друзей!`,
		},
	]);

	constructor() {
		setInterval(() => {
			let value = this.onlinePlayers.getValue();
			if (Math.random() > 0.5) {
				value += Math.round(Math.random() * 10);
			} else {
				value -= Math.round(Math.random() * 10);
			}
			if (value < 0) {
				value = 0;
			}

			this.onlinePlayers.next(value);
		}, 2500);

		let activitySeconds = 600;

		let gameTime = 500;
		setInterval(() => {
			activitySeconds -= 1;

			gameTime += 1;
			if (gameTime >= 1440) {
				gameTime = 0;
			}
			const gameTimeStr = formatTime(gameTime * 60 * 1000, '{hh}:{mm}');
			this.gameTime.next(gameTimeStr);
			this.realTime.next({
				time: gameTimeStr,
				weekday: 'Четверг',
				date: '17 октября',
				weekdayShort: 'чт',
				dateShort: '17 окт.',
				month: 'Октябрь',
			});
		}, 1000);

		this.activityTimer.next({
			icon: GameplayActivityTimerIcon.RentCar,
			duration: activitySeconds * 1000,
		});

		let counter = 0;
		const counterWordForms: [string, string, string] = [
			'заказ',
			'заказа',
			'заказов',
		];

		setTimeout(
			() =>
				setInterval(() => {
					counter = (counter + 1) % 1001;

					this.jobProgress.next({
						icon: GameplayJobProgressIcon.Delivery,
						counter,
						counterWordForms,
						currencyIcon: Currency.Ruble,
						currencyAmount: counter * 1000,
					});
				}, 1000),
			3000,
		);

		(global as any).setDefaultMainMenuTab = (tab: MainMenuTabs | null) => {
			this.defaultMainMenuTab.next(tab);
		};
	}

	public getServerNewsPosts(): IObservable<IServerNewsPostShort[]> {
		return this.serverNews;
	}

	public async getServerNewsPost(id: string): Promise<IServerNewsPost | null> {
		const news = this.serverNews.getValue();
		return news.find((post) => post.id === id) || null;
	}

	public getOnlinePlayers(): IObservable<number> {
		return this.onlinePlayers;
	}

	public getActivityTimer(): IObservable<IGameplayActivityTimer | null> {
		return this.activityTimer;
	}

	public resetActivityTimer(): void {
		this.activityTimer.next(null);
	}

	public getJobProgress(): IObservable<IGameplayJobProgress | null> {
		return this.jobProgress;
	}

	public getGameTime(): IObservable<string> {
		return this.gameTime;
	}

	public getRealTime(): IObservable<IRealTime> {
		return this.realTime;
	}

	public getArea(): IObservable<IGameArea> {
		return this.area;
	}

	public getServerId(): IObservable<string> {
		return this.serverId;
	}

	public getServerName(): IObservable<string> {
		return this.serverName;
	}

	public getActivePromotion(): IObservable<PromotionType | null> {
		return this.activePromotion;
	}

	public getDefaultMainMenuTab(): IObservable<MainMenuTabs | null> {
		return this.defaultMainMenuTab;
	}

	public closeMainMenu(): void {
		console.log('closeMainMenu');
	}

	public getInteractState(): IObservable<boolean> {
		return this.interactVisible;
	}

	public getIsInGreenZone(): IObservable<boolean> {
		return this.isInGreenZone;
	}
}
